import { Backdrop, CircularProgress, Typography, IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import usePageTitle from "../../../Common/hooks/usePageTitle";
import TopBar from "../../../Layout/components/TopBar/TopBar";
import PackageHistoryGrid from "../components/PackageHistoryGrid/PackageHistoryGrid";
import { getPackageHistory } from "../api/adminPackageClient";
import { PackageHistoryDto } from "../api/models/PackageDto";
import styles from "./PackageHistoryView.module.scss";

const PackageHistoryView = (): JSX.Element => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [history, setHistory] = useState<PackageHistoryDto[]>([]);
    usePageTitle("Admin | Package History");

    const handleBack = () => {
        navigate("/admin/packages");
    };

    const fetchData = async () => {
        if (!id) return;
        
        setIsLoading(true);
        try {
            const historyData = await getPackageHistory(id);
            setHistory(historyData);
        } catch (error) {
            console.error("Failed to fetch package history:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [id]);

    if (!id) {
        return <div>Invalid package ID</div>;
    }

    return (
        <div id="packagehistory" data-testid="packagehistory" style={{ height: "100%" }}>
            <TopBar>
                <div className={styles.details__topBarContainer}>
                    <IconButton onClick={handleBack} sx={{ mr: 2 }}>
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h4">Package History</Typography>
                </div>
            </TopBar>

            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <PackageHistoryGrid 
                packageId={id}
                history={history} 
                reloadData={fetchData} 
                setIsLoading={setIsLoading} 
            />
        </div>
    );
};

export default PackageHistoryView;